import { render } from "./OlabSeed.vue?vue&type=template&id=4c39c2fd&scoped=true"
import script from "./OlabSeed.vue?vue&type=script&lang=js"
export * from "./OlabSeed.vue?vue&type=script&lang=js"

import "./OlabSeed.vue?vue&type=style&index=0&id=4c39c2fd&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c39c2fd"]])

export default __exports__